import DictionaryTypes from '../../models/dictionary-types';
import Subjects from '../../models/subjects';
import { SelectorStore } from './selector-store';

export default class TagsStore extends SelectorStore {

    constructor(subject: Subjects) {
        super(subject, DictionaryTypes.tags);
    }
}